import { render } from "./NewInvestmentButton.vue?vue&type=template&id=23fe467a"
import script from "./NewInvestmentButton.vue?vue&type=script&lang=js"
export * from "./NewInvestmentButton.vue?vue&type=script&lang=js"
script.render = render

export default script